// Copyright (C) 2020 TANNER AG

import React from "react";
import { compose } from "recompose";
import * as PropTypes from "prop-types";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import classnames from "classnames";

const styles = theme => ({
    root: {
        textTransform: "capitalize",
        marginRight: 4,
        padding: "2px 4px",
        minHeight: 22,
        fontSize: 11,
        color: "#838a92"
    },
    selected: {
        backgroundColor: "#e40045",
        borderColor: "#e40045",
        color: "#fff"
    }
})

const PodcastsKeyword = ({ label, classes, selected, onClick }) => {
    return (
        <Button
            className={classnames(classes.root, { [classes.selected]: selected })}
            size="small"
            variant="outlined"
            onClick={onClick}
        >
            {label}
        </Button>
    );
};

PodcastsKeyword.propTypes = {
    label: PropTypes.string.isRequired,
    selected: PropTypes.bool,
    onClick: PropTypes.func
};

export default compose(
    withStyles(styles)
)(PodcastsKeyword);



// WEBPACK FOOTER //
// ./src/components/PodcastsKeyword.js